import Alpine from "alpinejs"
import { Splide } from "@splidejs/splide"

Alpine.data("articleSlider", () => ({
    splide: null,
    splideOptions: {
        type: "slide",
        drag: true,
        gap: "1rem",
        perPage: 1,
        padding: { right: "20%" },
        arrows: false,
        isNavigation: false,
        pagination: false,
        breakpoints: {
            0: {
                padding: { right: "0%" },
                autoWidth: false,
            },
            320: {
                padding: { right: "5%" },
                perPage: 1,
                autoWidth: false,
            },
            410: {
                padding: { right: "20%" },
                perPage: 1,
                autoWidth: false,
            },
            800: {
                padding: { right: "20%" },
                perPage: 1,
                autoWidth: true,
            },
            1054: {
                padding: { right: "20%" },
                perPage: 2,
                autoWidth: true,
            },
            1055: {
                padding: { right: "30%" },
                perPage: 1,
                autoWidth: true,
            },
            1860: {
                padding: { right: "40%" },
                perPage: 1,
                autoWidth: true,
            },
            3000: {
                padding: { right: "60%" },
                perPage: 1,
                autoWidth: true,
            },
        },
    },
    next: function() {
        this.splide.go("+1")
        this.updateControls()
    },
    prev: function() {
        this.splide.go("-1")
        this.updateControls()
    },
    updateControls() {
        const prevButton = this.$refs.prevButton
        const nextButton = this.$refs.nextButton

        // Disable prev button if we're on the first slide
        if (this.splide.index === 0) {
            prevButton.classList.add("disabled")
        } else {
            prevButton.classList.remove("disabled")
        }

        // Disable next button if we're on the last slide
        if (this.splide.index === this.splide.length - this.splide.options.perPage) {
            nextButton.classList.add("disabled")
        } else {
            nextButton.classList.remove("disabled")
        }
    },
    init() {
        this.splide = new Splide(this.$refs.slider, this.splideOptions).mount()

        // Call updateControls initially to disable buttons if needed
        this.splide.on("mounted move", () => {
            this.updateControls()
        })
    },
}))
